import { render, staticRenderFns } from "./ShiftLoadsInfoTable.vue?vue&type=template&id=945b2158"
import script from "./ShiftLoadsInfoTable.vue?vue&type=script&lang=js"
export * from "./ShiftLoadsInfoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports